import { HromadneVyhodnotenie as HromadneVyhodnotenieDto, HromadneVyhodnotenieApi } from 'pripomienky-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import HromadneVyhodnotenie from '../model/HromadneVyhodnotenie';
import apiConfiguration from './configuration/apiConfiguration';
import { pripomienkyPrefixPath } from './configuration/apiConfigurationConstants';
import { stavPripomienkyToGenerated } from '../model/pripomienka/StavPripomienky';
import ClassType, { classTypeToGenerated } from '../model/pripomienka/ClassType';
import { ClientResponse } from '../model/ClientResponse';

const client = new HromadneVyhodnotenieApi(apiConfiguration(pripomienkyPrefixPath));

const map = (vyhodnotenie: HromadneVyhodnotenie): HromadneVyhodnotenieDto => ({
  pripomienkaUuidList: vyhodnotenie.pripomienkaUuidList,
  stavPripomienky: stavPripomienkyToGenerated(vyhodnotenie.stavPripomienky),
  textVyhodnotenia: vyhodnotenie.textVyhodnotenia,
});

// eslint-disable-next-line import/prefer-default-export
export const hromadneVyhodnotit = async (
  classType: ClassType,
  type: string,
  year: number,
  index: number,
  vyhodnotenie: HromadneVyhodnotenie,
  options?: AxiosRequestConfig,
): Promise<ClientResponse<void>> => {
  const { status } = await client.hromadneVyhodnotit(
    classTypeToGenerated(classType),
    type,
    year,
    index,
    map(vyhodnotenie),
    options,
  );

  return { responseCode: status };
};
